<div id="library-moocs" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">MOOCs — Online Learning Resources</h2>
    <p class="inner-lead mt-3">
      Shah Satnam Ji Girls' College, Sirsa encourages students to enhance their knowledge through Massive Open Online
      Courses (MOOCs). Students can access free and paid online courses from leading platforms like SWAYAM, Coursera,
      and edX to complement their regular curriculum.
    </p>
    <hr class="divider">
    <h4 class="section-subtitle">Recommended Platforms</h4>
    <ul class="download-list mt-3">
      <li class="download-item">
        <span class="download-item-label">SWAYAM — Government of India Free Online Courses</span>
        <a href="https://swayam.gov.in" target="_blank" class="download-btn">
          <i class="fa fa-external-link"></i> Visit
        </a>
      </li>
      <li class="download-item">
        <span class="download-item-label">NPTEL — National Programme on Technology Enhanced Learning</span>
        <a href="https://nptel.ac.in" target="_blank" class="download-btn">
          <i class="fa fa-external-link"></i> Visit
        </a>
      </li>
      <li class="download-item">
        <span class="download-item-label">Coursera — University-level Online Courses</span>
        <a href="https://www.coursera.org" target="_blank" class="download-btn">
          <i class="fa fa-external-link"></i> Visit
        </a>
      </li>
      <li class="download-item">
        <span class="download-item-label">edX — Free Online Courses from Top Universities</span>
        <a href="https://www.edx.org" target="_blank" class="download-btn">
          <i class="fa fa-external-link"></i> Visit
        </a>
      </li>
      <li class="download-item">
        <span class="download-item-label">Download MOOCs Resource Guide</span>
        <a href="https://swayam.gov.in" target="_blank" class="download-btn">
          <i class="fa fa-external-link"></i> Visit
        </a>
      </li>
    </ul>
  </div>
</div>